import { defineComponent, watch } from 'vue'
import {
  useChildren,
  useCustomFieldValue,
  useNamespace,
} from '@xzx-design/hooks'
import { radioGroupEmits, radioGroupProps } from './radio-group'
import { RADIO_KEY } from './types'

const name = 'XzxRadioGroup'

export default defineComponent({
  name,
  __name: name,
  props: radioGroupProps,
  emits: radioGroupEmits,
  setup(props, { emit, slots }) {
    const { m } = useNamespace('radio-group')

    const { linkChildren } = useChildren(RADIO_KEY)

    const updateValue = (value: unknown) => emit('update:modelValue', value)

    watch(
      () => props.modelValue,
      (value) => emit('change', value)
    )

    linkChildren({
      props,
      updateValue,
    })

    useCustomFieldValue(() => props.modelValue)

    return () => (
      <div class={m(props.direction)} role="radiogroup">
        {slots.default?.()}
      </div>
    )
  },
})
